import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    modalOpen : false,
    uploading: false,
    selectedBucket : null,
    arquivos : [],
    buckets: [],
    form : {
      remetente : "",
      file : null,
      bucket : "",
      path : "",
      erro : "",
      encryptKey: "",
    },
    formDownloadEncrypted : {
      url: false, 
      password : "",
      link : false
    }
}

export const storageSlice = createSlice({
    name: "storage",
    initialState,
    reducers: {
      setModalOpen: (state, action) => {
        state.modalOpen = action.payload
      },
      setFormAttribute: (state, action) => {
        state.form[action.payload.campo] = action.payload.valor
      },
      cleanForm : (state) => {
        state.form = {
          remetente : "",
          file : null,
          bucket : "anano.manager.geral",
          path : "",
          erro : "",
          encryptKey: "",
        }
      },
      triggerEnviaForm : () => {},
      defineErroStorage : (state, action) => {
        state.form.erro = action.payload
      }, 
      triggerCarregaBuckets : () => {},
      defineStorageBuckets : (state, action) => {
        state.buckets = action.payload
      },
      defineUploading : (state, action) => {
        state.uploading = action.payload
      },
      triggerSelectBucket: () => {},
      setSelectedBucket: (state, action) => {
        state.selectedBucket = action.payload 
      },
      setArquivos : (state, action) => {
        state.arquivos = action.payload
      },
      triggerRemoveFile: () => {},
      updateAttributeFormEncrypted : (state, action) => {
        state.formDownloadEncrypted[action.payload.campo] = action.payload.value
      },
      cleanFormEncrypted: (state) => {
        state.formDownloadEncrypted = {
          url: false, 
          password : "",
          link : false
        }
      }
}})

export const {
    setModalOpen,
    setFormAttribute,
    cleanForm,
    triggerEnviaForm,
    defineErroStorage,
    triggerCarregaBuckets,
    defineStorageBuckets,
    defineUploading,
    triggerSelectBucket,
    setSelectedBucket,
    setArquivos,
    triggerRemoveFile,
    updateAttributeFormEncrypted,
    cleanFormEncrypted
} = storageSlice.actions;


export default storageSlice.reducer;